// src/hooks/useBreakpointValue.tsx
import { useContext } from "react";
import {
  useBreakpointValue as chakraBreakpointValue,
  useMediaQuery
} from "@chakra-ui/react";

// src/providers/StockXGoldResponsive.tsx
import React, { useMemo } from "react";
import Bowser from "bowser";
import { jsx } from "react/jsx-runtime";
var ResponsiveContext = React.createContext({ ssrSize: "base" });
var BREAKPOINT_SIZE_MAP = {
  mobile: "base",
  tablet: "md",
  desktop: "lg",
  xldesktop: "xl"
};
var StockXGoldResponsive = ({ children, req }) => {
  const userAgent = req.headers["user-agent"] ?? false;
  const value = useMemo(() => {
    let predictedDeviceWidth = BREAKPOINT_SIZE_MAP.mobile;
    if (userAgent) {
      const deviceData = Bowser.parse(userAgent);
      const {
        platform: { type }
      } = deviceData;
      if (type && BREAKPOINT_SIZE_MAP[type]) {
        predictedDeviceWidth = BREAKPOINT_SIZE_MAP[type];
      }
      if (type === "bot" && !userAgent.includes("Mobile")) {
        predictedDeviceWidth = BREAKPOINT_SIZE_MAP.desktop;
      }
    }
    return { ssrSize: predictedDeviceWidth };
  }, [userAgent]);
  return /* @__PURE__ */ jsx(ResponsiveContext.Provider, { value, children });
};
var StockXGoldResponsive_default = StockXGoldResponsive;

// src/utils/renderContext.ts
var isServer = typeof window === "undefined";

// src/hooks/useBreakpointValue.tsx
var getSize = ({
  isMobile,
  isTablet,
  isDesktop,
  isXlDesktop
}) => {
  if (isMobile) {
    return "isMobile";
  }
  if (isTablet) {
    return "isTablet";
  }
  if (isDesktop) {
    return "isDesktop";
  }
  if (isXlDesktop) {
    return "isXlDesktop";
  }
};
var useBreakpointValue = () => {
  const { ssrSize } = useContext(ResponsiveContext);
  const ssrSizeEstimate = chakraBreakpointValue(
    {
      base: "isMobile",
      md: "isTablet",
      lg: "isDesktop",
      xl: "isXlDesktop"
    },
    ssrSize
  );
  if (isServer) {
    return {
      size: ssrSizeEstimate,
      isMobile: ssrSizeEstimate === "isMobile",
      isTablet: ssrSizeEstimate === "isTablet",
      isDesktop: ssrSizeEstimate === "isDesktop",
      isXlDesktop: ssrSizeEstimate === "isXlDesktop"
    };
  }
  const [isMobile, isTablet, isDesktop, isXlDesktop] = useMediaQuery(
    [
      `(min-width: ${320 /* mobile */}px) and (max-width: ${767 /* mobile */}px)`,
      `(min-width: ${768 /* tablet */}px) and (max-width: ${1023 /* tablet */}px)`,
      `(min-width: ${1024 /* desktop */}px) and (max-width: ${1439 /* desktop */}px)`,
      `(min-width: ${1440 /* xldesktop */}px)`
    ],
    {
      // disable since we handle ssr above
      ssr: false
    }
  );
  const size = getSize({ isMobile, isTablet, isDesktop, isXlDesktop });
  return {
    size,
    isMobile,
    isTablet,
    isDesktop,
    isXlDesktop
  };
};
var useBreakpointValue_default = useBreakpointValue;

// src/components/Wrappers.tsx
var Mobile = ({ children }) => {
  const { isMobile } = useBreakpointValue_default();
  return isMobile ? children : null;
};
var MobileAndTablet = ({ children }) => {
  const { isMobile, isTablet } = useBreakpointValue_default();
  return isMobile || isTablet ? children : null;
};
var Tablet = ({ children }) => {
  const { isTablet } = useBreakpointValue_default();
  return isTablet ? children : null;
};
var TabletAndDesktop = ({ children }) => {
  const { isTablet, isDesktop, isXlDesktop } = useBreakpointValue_default();
  return isTablet || isDesktop || isXlDesktop ? children : null;
};
var Desktop = ({ children }) => {
  const { isDesktop, isXlDesktop } = useBreakpointValue_default();
  return isDesktop || isXlDesktop ? children : null;
};
var XlDesktop = ({ children }) => {
  const { isXlDesktop } = useBreakpointValue_default();
  return isXlDesktop ? children : null;
};
export {
  Desktop,
  Mobile,
  MobileAndTablet,
  StockXGoldResponsive_default as StockXGoldResponsive,
  Tablet,
  TabletAndDesktop,
  XlDesktop,
  useBreakpointValue_default as useBreakpointValue
};
